import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { DeliveryDpdForm } from '@pt/models';

@Component({
  standalone: false,
  selector: 'pu-delivery-view-dpd',
  templateUrl: './dpd.component.html',
  styleUrls: ['./dpd.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DpdComponent {
  delivery = input<DeliveryDpdForm>();
}
